module.exports = __webpack_public_path__ + "img/new-bg.c4666bb6.png";